import Login from '../Login/Login';
import UserRegister from '../UserRegister/UserRegister';
import Roles from '../Admin/Roles/Roles';
import AdminIndex from '../Admin/AdminIndex/AdminIndex';
import Users from '../Admin/Users/Users';
import TaskTypes from '../Admin/TaskTypes/TaskTypes';
import ForgotPassword from '../Forgot/ForgotPassword';
import { BrowserRouter, Route, Navigate, Routes } from 'react-router-dom';
import RouteGuard from '../../utils/RouteGuard';
import RouteGuardIsAuthenticated from '../../utils/RouteGuardIsAuthenticated';
import Dashboard from '../Dashboard/Dashboard';
import DashboardIndex from '../Dashboard/DashboardIndex/DashboardIndex';
import Tasks from '../Gestion/Tasks/Tasks';
import Catastro from '../Catastro/Catastro';
import Register from '../Register/Register';
import TaskMap from '../Gestion/TaskMap/TaskMap';
import Reports from '../Gestion/Reports/Reports';
export interface IHomeProps {}
const Main: React.FunctionComponent<IHomeProps> = (props) => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<RouteGuard />}>
          <Route path="dashboard" element={<Dashboard />}>
            <Route index element={<DashboardIndex />} />
          </Route>
          <Route path="admin" element={<AdminIndex />} />
          <Route path="admin/roles" element={<Roles />} />
          <Route path="admin/usuarios" element={<Users />} />
          <Route path="admin/tipos-tareas" element={<TaskTypes />} />
          <Route path="tareas" element={<Tasks />} />
          <Route path="tareas/visualizar/:id" element={<TaskMap editing={false} />} />
          <Route path="tareas/editar/:id" element={<TaskMap editing={true} />} />
          <Route path="tareas/crear" element={<TaskMap editing={true} />} />
          <Route path="/gestor-de-capas" element={<Catastro />} />
          <Route path="/gestor-de-registros" element={<Register />} />
          <Route path="/reportes" element={<Reports />} />
        </Route>
        <Route element={<RouteGuardIsAuthenticated />}>
          <Route path="/login" element={<Login />} />
        </Route>
        <Route path="/forgot_password" element={<ForgotPassword />} />
        <Route path="/register">
          <Route index element={<UserRegister />} />
        </Route>
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Main;
